import { gql } from '@apollo/client';

const LATEST_APP_VERSION_QUERY = gql`
  query latestAppVersion($appName: String!, $platform: String!) {
    latestAppVersion(appName: $appName, platform: $platform) {
      isSuccess
      message
      latestVersion
    }
  }
`;

export default LATEST_APP_VERSION_QUERY;
